import axios from 'axios';

export function normalizeError(error: unknown): never {
  if (axios.isAxiosError(error)) {
    throw error;
  }
  if (error instanceof Error) {
    throw new Error(`API request failed: ${error.message}`);
  }
  throw new Error('API request failed: Unknown error');
}
